import { render, staticRenderFns } from "./VouchersBuy.vue?vue&type=template&id=8e0609f4&"
import script from "./VouchersBuy.vue?vue&type=script&lang=js&"
export * from "./VouchersBuy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e0609f4')) {
      api.createRecord('8e0609f4', component.options)
    } else {
      api.reload('8e0609f4', component.options)
    }
    module.hot.accept("./VouchersBuy.vue?vue&type=template&id=8e0609f4&", function () {
      api.rerender('8e0609f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/VouchersBuy.vue"
export default component.exports